// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"SearchTextField-primaryButton-1JxvLP","textField":"SearchTextField-textField-2UXwug","label":"SearchTextField-label-183RUC"};